<template>
  <div class="page">
    <van-nav-bar :title="config[pageIndex].pageTitle" left-arrow @click-left="$router.go(-1)" fixed :placeholder="true" :safe-area-inset-top="true" />
    <div class="header">
      <div class="left">
        <div class="title">{{ pageData[config[pageIndex].title] }}</div>
        <div class="info">姓名：{{ pageData[config[pageIndex].name] }}（{{ pageData[config[pageIndex].studentId] }}）</div>
        <div class="info">班级：{{ pageData[config[pageIndex].classId] }}</div>
      </div>
      <img src="../../../../assets/images/sx_dsp.png" v-if="pageData[config[pageIndex].status] == 2 || pageData[config[pageIndex].status] == 3" alt="" />
      <img src="../../../../assets/images/sx_wtg.png" v-if="pageData[config[pageIndex].status] == 0" alt="" />
      <img src="../../../../assets/images/sx_ytg.png" v-if="pageData[config[pageIndex].status] == 1" alt="" />
    </div>
    <!-- 项目变更 -->
    <div class="change-box" v-if="pageIndex == 6 && (pageData.ygwmc != '' || pageData.ysxqymc != '')">
      <div class="item-box" v-if="!pageData.ysxqymc == ''">
        <div class="title">单位名称</div>
        <div class="change-item">
          <div class="point"></div>
          <div class="name">{{ pageData.ssqy }}</div>
        </div>
        <div class="change-item" style="border-color: #fff">
          <div class="point" :style="{ backgroundColor: getStatusColor(pageData[config[pageIndex].status]) }"></div>
          <div class="name" :style="{ color: getStatusColor(pageData[config[pageIndex].status]) }">{{ pageData.ysxqymc }}</div>
        </div>
      </div>
      <div class="item-box" style="margin-top: 10px;border: none" v-if="!pageData.ygwmc == ''">
        <div class="title">岗位名称</div>
        <div class="change-item">
          <div class="point"></div>
          <div class="name">{{ pageData.ygwmc }}</div>
        </div>
        <div class="change-item" style="border-color: #fff">
          <div class="point" :style="{ backgroundColor: getStatusColor(pageData[config[pageIndex].status]) }"></div>
          <div class="name" :style="{ color: getStatusColor(pageData[config[pageIndex].status]) }">{{ pageData.gwmc }}</div>
        </div>
      </div>
    </div>
    <!-- 审批意见 -->
    <div class="reject-box" :style="{ backgroundImage: getRejectColor, color: getRejectTextColor }" v-if="pageData[config[pageIndex].status] == 0 || pageData[config[pageIndex].status] == 1">
      <div>审批意见：</div>
      <div>{{ pageData[config[pageIndex].refuseReason] }}</div>
    </div>


    <div class="info-box" v-if="schoolCode == '10422'" v-for="(item, index) in config[pageIndex].infoList_10422" :key="index">
      <div class="title">{{ item.title }}</div>
      <div class="item-box" style="min-height: 50px;">
        <div class="item" :class="[getItemType(child.name) == true ? 'column' : '']" v-for="(child, idx) in item.list" :key="'child' + idx">
          <div class="name">{{ child.name }}</div>
          <div class="content" v-if="!getItemTypePictrue(child.name)">{{ pageData[child.key] }}</div>
          <van-grid :border="false" :column-num="3" v-if="getItemTypePictrue(child.name)">
            <van-grid-item>
              <van-image v-if="pageData[child.key] != ''" :src="pageData[child.key]" />
            </van-grid-item>
          </van-grid>
        </div>
      </div>
      <!-- 重新申请按钮 -->
      <div class="button-box" v-if="pageData[config[pageIndex].status] == 0">
        <div class="button" @click="reApply()">重新申请</div>
      </div>
    </div>
    <div class="info-box" v-else-if="schoolCode == '14475'" v-for="(item, index) in config[pageIndex].infoList_14475" :key="index">
      <div class="title">{{ item.title }}</div>
      <div class="item-box">
        <div class="item" :class="[getItemType(child.name) == true ? 'column' : '']" v-for="(child, idx) in item.list" :key="'child' + idx">
          <div class="name">{{ child.name }}</div>
          <div class="content" v-if="!getItemTypePictrue(child.name)">{{ pageData[child.key] }}</div>
          <van-grid :border="false" :column-num="3" v-if="getItemTypePictrue(child.name)">
            <van-grid-item>
              <van-image v-if="pageData[child.key] != ''" :src="pageData[child.key]" />
            </van-grid-item>
          </van-grid>
        </div>
      </div>
      <!-- 重新申请按钮 -->
      <div class="button-box" v-if="pageData[config[pageIndex].status] == 0">
        <div class="button" @click="reApply()">重新申请</div>
      </div>
    </div>
    <div class="info-box" v-else v-for="(item, index) in config[pageIndex].infoList" :key="index">
      <div class="title">{{ item.title }}</div>
      <div class="item-box">
        <div class="item" :class="[getItemType(child.name) == true ? 'column' : '']" v-for="(child, idx) in item.list" :key="'child' + idx">
          <div class="name">{{ child.name }}</div>
          <div class="content" v-if="!getItemTypePictrue(child.name)">{{ pageData[child.key] }}</div>
          <van-grid :border="false" :column-num="3" v-if="getItemTypePictrue(child.name)">
            <van-grid-item>
              <van-image v-if="pageData[child.key] != ''" :src="pageData[child.key]" />
            </van-grid-item>
          </van-grid>
        </div>
      </div>
      <!-- 重新申请按钮 -->
      <div class="button-box" v-if="pageData[config[pageIndex].status] == 0">
        <div class="button" @click="reApply()">重新申请</div>
      </div>
    </div>
  </div>

</template>

<script>
import iApi from '@/utils/internship.js'
import { mapGetters } from 'vuex'
export default {
  components: {},
  data() {
    return {
      schoolCode:'',
      pageIndex: 0,
      pageData: {},
      list: [],
      params: {},
      config: [
        // 统一实习配置
        {
          pageTitle: '实习申请',
          type: '统一实习',
          status: '1', // 状态
          refuseReason: '', // 审核意见
          infoList: [
            // 用户填写的信息列表
            {
              title: '企事业单位信息', // 盒子标题
              list: [
                {
                  name: '实习基地',
                  key: '',
                },
                {
                  name: '所属单位',
                  key: '',
                },
                {
                  name: '基地类别',
                  key: '',
                },
                {
                  name: '基地负责人',
                  key: '',
                },
                {
                  name: '基地电话',
                  key: '',
                },
                {
                  name: '联系人邮箱',
                  key: '',
                },
                {
                  name: '基地地址',
                  key: '',
                },
              ],
            },
            {
              title: '岗位信息', // 盒子标题
              list: [
                {
                  name: '部门/科室',
                  key: '',
                },
                {
                  name: '岗位名称',
                  key: '',
                },
                {
                  name: '企业老师',
                  key: '',
                },
                {
                  name: '企业老师电话',
                  key: '',
                },
                {
                  name: '岗位类别',
                  key: '',
                },
                {
                  name: '岗位介绍',
                  key: '',
                },
                {
                  name: '工作内容',
                  key: '',
                },
              ],
            },
            {
              title: '实习信息', // 盒子标题
              list: [
                {
                  name: '校内指导教师',
                  key: '',
                },
                {
                  name: '开始时间',
                  key: '',
                },
                {
                  name: '结束时间',
                  key: '',
                },
                {
                  name: '专业对口',
                  key: '',
                },
                {
                  name: '附件',
                  key: '',
                },
              ],
            },
          ],
          infoList_10422: [
            // 用户填写的信息列表
            {
              title: '企事业单位信息', // 盒子标题
              list: [
                {
                  name: '实习基地',
                  key: '',
                },
                {
                  name: '所属单位',
                  key: '',
                },
                {
                  name: '基地类别',
                  key: '',
                },
                {
                  name: '基地负责人',
                  key: '',
                },
                {
                  name: '基地电话',
                  key: '',
                },
                {
                  name: '联系人邮箱',
                  key: '',
                },
                {
                  name: '基地地址',
                  key: '',
                },
              ],
            },
            {
              title: '实习信息', // 盒子标题
              list: [
                {
                  name: '校内指导教师',
                  key: '',
                },
                {
                  name: '开始时间',
                  key: '',
                },
                {
                  name: '结束时间',
                  key: '',
                },
                {
                  name: '专业对口',
                  key: '',
                },
                {
                  name: '附件',
                  key: '',
                },
              ],
            },
          ],
          infoList_14475: [
            // 用户填写的信息列表
            {
              title: '企事业单位信息', // 盒子标题
              list: [
                {
                  name: '实习基地',
                  key: '',
                },
                {
                  name: '所属单位',
                  key: '',
                },
                {
                  name: '基地类别',
                  key: '',
                },
                {
                  name: '基地负责人',
                  key: '',
                },
                {
                  name: '基地电话',
                  key: '',
                },
                {
                  name: '联系人邮箱',
                  key: '',
                },
                {
                  name: '基地地址',
                  key: '',
                },
              ],
            },
            {
              title: '岗位信息', // 盒子标题
              list: [
                {
                  name: '部门/科室',
                  key: '',
                },
                {
                  name: '岗位名称',
                  key: '',
                },
                {
                  name: '企业老师',
                  key: '',
                },
                {
                  name: '企业老师电话',
                  key: '',
                },
                {
                  name: '岗位类别',
                  key: '',
                },
                {
                  name: '岗位介绍',
                  key: '',
                },
                {
                  name: '工作内容',
                  key: '',
                },
              ],
            },
            {
              title: '实习信息', // 盒子标题
              list: [
                {
                  name: '校内指导教师',
                  key: '',
                },
                {
                  name: '开始时间',
                  key: '',
                },
                {
                  name: '结束时间',
                  key: '',
                },
                {
                  name: '专业对口',
                  key: '',
                },
                {
                  name: '附件',
                  key: '',
                },
              ],
            },
          ],
        },
        // 分散实习配置
        {
          pageTitle: '实习申请',
          type: '分散实习',
          title: 'sxjhmc',
          name: 'xsxm',
          classId: 'bj',
          studentId: 'xh',
          status: 'iswfmes', // 状态
          refuseReason: 'shyj', // 审核意见
          iApi: '/sxsqController/getSqzt',
          infoList: [
            // 用户填写的信息列表
            {
              title: '企事业单位信息', // 盒子标题
              list: [
                {
                  name: '企业名称',
                  key: 'qymctext',
                },
                {
                  name: sessionStorage.getItem("schoolCode") == '13772' ? '打卡定位地点名称' : '打卡企业',
                  key: 'qymc',
                },
                {
                  name: '统一社会信用代码',
                  key: 'tyshxydm',
                },
                {
                  name: '企业性质',
                  key: 'qyxz',
                },
                {
                  name: '行业类别',
                  key: 'hylb',
                },
                {
                  name: '所属行业',
                  key: 'sshy',
                },
                {
                  name: '所在城市',
                  key: 'cs',
                },
                {
                  name: '详细地址',
                  key: 'xxdz',
                },
                {
                  name: '企业人数规模',
                  key: 'qyrsgm',
                },
                {
                  name: '企业联系人',
                  key: 'qylxr',
                },
                {
                  name: '基地电话',
                  key: 'lxrdh',
                },
                {
                  name: '联系人邮箱',
                  key: 'lxryx',
                },
              ],
            },
            {
              title: '岗位信息', // 盒子标题
              list: [
                {
                  name: '部门/科室',
                  key: 'bm',
                },
                {
                  name: '岗位名称',
                  key: 'gwmc',
                },
                {
                  name: '企业老师',
                  key: 'xwzdjs',
                },
                {
                  name: '企业老师电话',
                  key: 'xwzdjslxfs',
                },
                {
                  name: '岗位类别',
                  key: 'gwlb',
                },
                {
                  name: '岗位介绍',
                  key: 'gwjs',
                },
                {
                  name: '工作内容',
                  key: 'gznr',
                },
              ],
            },
            {
              title: '实习信息', // 盒子标题
              list: [
                {
                  name: '校内指导教师',
                  key: 'xnzdjs',
                },
                {
                  name: '开始时间',
                  key: 'kssj',
                },
                {
                  name: '结束时间',
                  key: 'jssj',
                },
                {
                  name: '专业对口',
                  key: 'zydk',
                },
                {
                  name: sessionStorage.getItem("schoolCode") == '13772' ? '用人单位录用函' : '附件',
                  key: 'base64',
                },
              ],
            },
          ],
          infoList_10422: [
            // 用户填写的信息列表
            {
              title: '企事业单位信息', // 盒子标题
              list: [
                {
                  name: '企业名称',
                  key: 'qymctext',
                },
                {
                  name: sessionStorage.getItem("schoolCode") == '13772' ? '打卡定位地点名称' : '打卡企业',
                  key: 'qymc',
                },
                {
                  name: '统一社会信用代码',
                  key: 'tyshxydm',
                },
                {
                  name: '企业性质',
                  key: 'qyxz',
                },
                {
                  name: '行业类别',
                  key: 'hylb',
                },
                {
                  name: '所属行业',
                  key: 'sshy',
                },
                {
                  name: '所在城市',
                  key: 'cs',
                },
                {
                  name: '详细地址',
                  key: 'xxdz',
                },
                {
                  name: '企业人数规模',
                  key: 'qyrsgm',
                },
                {
                  name: '企业联系人',
                  key: 'qylxr',
                },
                {
                  name: '基地电话',
                  key: 'lxrdh',
                },
                {
                  name: '联系人邮箱',
                  key: 'lxryx',
                },
              ],
            },
            {
              title: '实习信息', // 盒子标题
              list: [
                {
                  name: '校内指导教师',
                  key: 'xnzdjs',
                },
                {
                  name: '开始时间',
                  key: 'kssj',
                },
                {
                  name: '结束时间',
                  key: 'jssj',
                },
                {
                  name: '专业对口',
                  key: 'zydk',
                },
                {
                  name: '附件',
                  key: 'base64',
                },
              ],
            },
          ],
          infoList_14475: [
            // 用户填写的信息列表
            {
              title: '企事业单位信息', // 盒子标题
              list: [
                {
                  name: '企业名称',
                  key: 'qymctext',
                },
                {
                  name: sessionStorage.getItem("schoolCode") == '13772' ? '打卡定位地点名称' : '打卡企业',
                  key: 'qymc',
                },
                {
                  name: '统一社会信用代码',
                  key: 'tyshxydm',
                },
                {
                  name: '企业性质',
                  key: 'qyxz',
                },
                {
                  name: '行业类别',
                  key: 'hylb',
                },
                {
                  name: '所属行业',
                  key: 'sshy',
                },
                {
                  name: '所在城市',
                  key: 'cs',
                },
                {
                  name: '详细地址',
                  key: 'xxdz',
                },
                {
                  name: '企业人数规模',
                  key: 'qyrsgm',
                },
                {
                  name: '企业联系人',
                  key: 'qylxr',
                },
                {
                  name: '基地电话',
                  key: 'lxrdh',
                },
                {
                  name: '联系人邮箱',
                  key: 'lxryx',
                },
              ],
            },
            {
              title: '岗位信息', // 盒子标题
              list: [
                {
                  name: '部门/科室',
                  key: 'bm',
                },
                {
                  name: '岗位名称',
                  key: 'gwmc',
                },
                {
                  name: '企业老师',
                  key: 'xwzdjs',
                },
                {
                  name: '企业老师电话',
                  key: 'xwzdjslxfs',
                },
                {
                  name: '岗位类别',
                  key: 'gwlb',
                },
                {
                  name: '岗位介绍',
                  key: 'gwjs',
                },
                {
                  name: '工作内容',
                  key: 'gznr',
                },
                {
                  name: '手机号码',
                  key: 'sjhm',
                },
                {
                  name: '实习天数(天/周)',
                  key: 'sxts',
                },
                {
                  name: '实习时长(小时/天)',
                  key: 'sxsc',
                },
                {
                  name: '实习报酬(元/月)',
                  key: 'sxbc',
                },
              ],
            },
            {
              title: '实习信息', // 盒子标题
              list: [
                {
                  name: '校内指导教师',
                  key: 'xnzdjs',
                },
                {
                  name: '开始时间',
                  key: 'kssj',
                },
                {
                  name: '结束时间',
                  key: 'jssj',
                },
                {
                  name: '专业对口',
                  key: 'zydk',
                },
                {
                  name: sessionStorage.getItem("schoolCode") == '13772' ? '用人单位录用函' : '附件',
                  key: 'base64',
                },
              ],
            },
          ],
        },
        // 实习项目配置
        {
          pageTitle: '实习项目',
          type: '实习项目',
          title: 'sxjhmc',
          name: 'xsxm',
          classId: 'bj',
          studentId: 'xh',
          status: 'iswfmes', // 状态
          refuseReason: 'shyj', // 审核意见
          iApi: '/sxxmController/sxxmxq',
          infoList: [
            // 用户填写的信息列表
            {
              title: '实习信息', // 盒子标题
              list: [
                {
                  name: '实习单位',
                  key: 'qymc',
                },
                {
                  name: '部门/科室',
                  key: 'bmks',
                },
                {
                  name: '实习岗位',
                  key: 'gwmc',
                },
              ],
            },
            {
              title: '项目信息', // 盒子标题
              list: [
                {
                  name: '开始时间',
                  key: 'xmkssj',
                },
                {
                  name: '结束时间',
                  key: 'xmjssj',
                },
                {
                  name: '带队教师',
                  key: 'djjs',
                },
                {
                  name: '教师联系方式',
                  key: 'lxfs',
                },
                {
                  name: '项目名称',
                  key: 'xmmc',
                },
                {
                  name: '项目描述',
                  key: 'xmms',
                },
                {
                  name: '自我评价',
                  key: 'zwpj',
                },
              ],
            },
          ],
          infoList_10422: [
            // 用户填写的信息列表
            {
              title: '实习信息', // 盒子标题
              list: [
                {
                  name: '实习单位',
                  key: 'qymc',
                }
              ],
            },
            {
              title: '项目信息', // 盒子标题
              list: [
                {
                  name: '开始时间',
                  key: 'xmkssj',
                },
                {
                  name: '结束时间',
                  key: 'xmjssj',
                },
                {
                  name: '带队教师',
                  key: 'djjs',
                },
                {
                  name: '教师联系方式',
                  key: 'lxfs',
                },
                {
                  name: '项目名称',
                  key: 'xmmc',
                },
                {
                  name: '项目描述',
                  key: 'xmms',
                },
                {
                  name: '自我评价',
                  key: 'zwpj',
                },
              ],
            },
          ],
          infoList_14475: [
            // 用户填写的信息列表
            {
              title: '实习信息', // 盒子标题
              list: [
                {
                  name: '实习单位',
                  key: 'qymc',
                },
                {
                  name: '部门/科室',
                  key: 'bmks',
                },
                {
                  name: '实习岗位',
                  key: 'gwmc',
                },
              ],
            },
            {
              title: '项目信息', // 盒子标题
              list: [
                {
                  name: '开始时间',
                  key: 'xmkssj',
                },
                {
                  name: '结束时间',
                  key: 'xmjssj',
                },
                {
                  name: '带队教师',
                  key: 'djjs',
                },
                {
                  name: '教师联系方式',
                  key: 'lxfs',
                },
                {
                  name: '项目名称',
                  key: 'xmmc',
                },
                {
                  name: '项目描述',
                  key: 'xmms',
                },
                {
                  name: '自我评价',
                  key: 'zwpj',
                },
              ],
            },
          ],
        },
        // 免实习配置
        {
          pageTitle: '免实习申请',
          type: '免实习申请',
          title: 'sxjhmc',
          name: 'xm',
          classId: 'bj',
          studentId: 'xh',
          status: 'iswfmes', // 状态
          refuseReason: 'shyj', // 审核意见
          iApi: '/MsxsqController/getSqzt',
          infoList: [
            // 用户填写的信息列表
            {
              title: '学生信息', // 盒子标题
              list: [
                {
                  name: '所属院系',
                  key: 'yx',
                },
                {
                  name: '上课年级',
                  key: 'bj',
                },
                {
                  name: '上课专业',
                  key: 'zymc',
                },
                {
                  name: '上课班级',
                  key: 'bj',
                },
                {
                  name: '联系电话',
                  key: 'dh',
                },
              ],
            },
            {
              title: '免实习申请信息', // 盒子标题
              list: [
                {
                  name: '申请原因',
                  key: 'sqyy',
                },
                // {
                //   name: '去向',
                //   key: 'dmmc',
                // },
                {
                  name: '证明文件',
                  key: 'base64',
                },
              ],
            },
          ],
          infoList_10422: [
            // 用户填写的信息列表
            {
              title: '学生信息', // 盒子标题
              list: [
                {
                  name: '所属院系',
                  key: 'yx',
                },
                {
                  name: '上课年级',
                  key: 'bj',
                },
                {
                  name: '上课专业',
                  key: 'zymc',
                },
                {
                  name: '上课班级',
                  key: 'bj',
                },
                {
                  name: '联系电话',
                  key: 'dh',
                },
              ],
            },
            {
              title: '免实习申请信息', // 盒子标题
              list: [
                {
                  name: '申请原因',
                  key: 'sqyy',
                },
                // {
                //   name: '去向',
                //   key: 'dmmc',
                // },
                {
                  name: '证明文件',
                  key: 'base64',
                },
              ],
            },
          ],
          infoList_14475: [
            // 用户填写的信息列表
            {
              title: '学生信息', // 盒子标题
              list: [
                {
                  name: '所属院系',
                  key: 'yx',
                },
                {
                  name: '上课年级',
                  key: 'bj',
                },
                {
                  name: '上课专业',
                  key: 'zymc',
                },
                {
                  name: '上课班级',
                  key: 'bj',
                },
                {
                  name: '联系电话',
                  key: 'dh',
                },
              ],
            },
            {
              title: '免实习申请信息', // 盒子标题
              list: [
                {
                  name: '申请原因',
                  key: 'sqyy',
                },
                // {
                //   name: '去向',
                //   key: 'dmmc',
                // },
                {
                  name: '证明文件',
                  key: 'base64',
                },
              ],
            },
          ],
        },
        // 免签申请配置
        {
          pageTitle: '免签申请',
          type: '免签申请',
          title: 'title',
          name: 'xsxm',
          classId: 'bjmc',
          studentId: 'xh',
          status: 'iswfmes', // 状态
          refuseReason: 'shyj', // 审核意见
          iApi: '/student/getMqsq',
          infoList: [
            // 用户填写的信息列表
            {
              title: '', // 盒子标题
              list: [
                {
                  name: '单位名称',
                  key: 'qymc',
                },
                {
                  name: '实习岗位',
                  key: 'gwmc',
                },
                {
                  name: '开始时间',
                  key: 'kssj',
                },
                {
                  name: '结束时间',
                  key: 'jssj',
                },
                {
                  name: '免签时长',
                  key: 'mqsc',
                },
                {
                  name: '提交时间',
                  key: 'sqsj',
                },
              ],
            },
            {
              title: '', // 盒子标题
              list: [
                {
                  name: '申请事由',
                  key: 'sqsy',
                },
                {
                  name: '图片',
                  key: 'filebase64',
                },
              ],
            },
          ],
          infoList_10422: [
            // 用户填写的信息列表
            {
              title: '', // 盒子标题
              list: [
                {
                  name: '单位名称',
                  key: 'qymc',
                },
                {
                  name: '开始时间',
                  key: 'kssj',
                },
                {
                  name: '结束时间',
                  key: 'jssj',
                },
                {
                  name: '免签时长',
                  key: 'mqsc',
                },
                {
                  name: '提交时间',
                  key: 'sqsj',
                },
              ],
            },
            {
              title: '', // 盒子标题
              list: [
                {
                  name: '申请事由',
                  key: 'sqsy',
                },
                {
                  name: '图片',
                  key: 'filebase64',
                },
              ],
            },
          ],
          infoList_14475: [
            // 用户填写的信息列表
            {
              title: '', // 盒子标题
              list: [
                {
                  name: '单位名称',
                  key: 'qymc',
                },
                {
                  name: '实习岗位',
                  key: 'gwmc',
                },
                {
                  name: '开始时间',
                  key: 'kssj',
                },
                {
                  name: '结束时间',
                  key: 'jssj',
                },
                {
                  name: '免签时长',
                  key: 'mqsc',
                },
                {
                  name: '提交时间',
                  key: 'sqsj',
                },
              ],
            },
            {
              title: '', // 盒子标题
              list: [
                {
                  name: '申请事由',
                  key: 'sqsy',
                },
                {
                  name: '图片',
                  key: 'filebase64',
                },
              ],
            },
          ],
        },
        // 请假申请配置
        {
          pageTitle: '请假申请',
          type: '请假申请',
          title: 'title',
          name: 'xsxm',
          classId: 'bjmc',
          studentId: 'xh',
          status: 'iswfmes', // 状态
          refuseReason: 'shyj', // 审核意见
          iApi: '/student/getQjsq',
          infoList : [
            // 用户填写的信息列表
            {
              title: '', // 盒子标题
              list: [
                {
                  name: '单位名称',
                  key: 'qymc',
                },
                {
                  name: '实习岗位',
                  key: 'gwmc',
                },
                {
                  name: '开始时间',
                  key: 'kssj',
                },
                {
                  name: '结束时间',
                  key: 'jssj',
                },
                {
                  name: '请假时长',
                  key: 'qjsc',
                },
                {
                  name: '提交时间',
                  key: 'sqsj',
                },
              ],
            },
            {
              title: '', // 盒子标题
              list: [
                {
                  name: '申请事由',
                  key: 'sqsy',
                },
                {
                  name: '证明材料',
                  key: 'filebase64',
                },
              ],
            },
          ],
          infoList_10422 : [
            // 用户填写的信息列表
            {
              title: '', // 盒子标题
              list: [
                {
                  name: '单位名称',
                  key: 'qymc',
                },
                {
                  name: '开始时间',
                  key: 'kssj',
                },
                {
                  name: '结束时间',
                  key: 'jssj',
                },
                {
                  name: '请假时长',
                  key: 'qjsc',
                },
                {
                  name: '提交时间',
                  key: 'sqsj',
                },
              ],
            },
            {
              title: '', // 盒子标题
              list: [
                {
                  name: '申请事由',
                  key: 'sqsy',
                },
                {
                  name: '证明材料',
                  key: 'filebase64',
                },
              ],
            },
          ],
          infoList_14475 : [
            // 用户填写的信息列表
            {
              title: '', // 盒子标题
              list: [
                {
                  name: '单位名称',
                  key: 'qymc',
                },
                {
                  name: '实习岗位',
                  key: 'gwmc',
                },
                {
                  name: '开始时间',
                  key: 'kssj',
                },
                {
                  name: '结束时间',
                  key: 'jssj',
                },
                {
                  name: '请假时长',
                  key: 'qjsc',
                },
                {
                  name: '提交时间',
                  key: 'sqsj',
                },
              ],
            },
            {
              title: '', // 盒子标题
              list: [
                {
                  name: '申请事由',
                  key: 'sqsy',
                },
                {
                  name: '证明材料',
                  key: 'filebase64',
                },
              ],
            },
          ],
        },
        // 统一实习变更
        {
          pageTitle: '实习变更',
          type: '实习变更',
          title: 'title',
          name: 'xsxm',
          classId: 'bj',
          studentId: 'xh',
          status: 'iswfmes', // 状态
          refuseReason: 'shyj', // 审核意见
          iApi: '/sxbgsqController/getTysxbgxq',
          infoList: [
            // 用户填写的信息列表
            {
              title: '企事业单位信息', // 盒子标题
              list: [
                {
                  name: '实习基地',
                  key: 'sxjdmc',
                },
                {
                  name: '所属单位',
                  key: 'ssqy',
                },
                {
                  name: '基地类别',
                  key: 'jdlbmc',
                },
                {
                  name: '基地负责人',
                  key: 'jdfzr',
                },
                {
                  name: '基地电话',
                  key: 'jddh',
                },
                {
                  name: '基地地址',
                  key: 'jddz',
                },
              ],
            },
            {
              title: '岗位信息', // 盒子标题
              list: [
                {
                  name: '部门/科室',
                  key: 'bmks',
                },
                {
                  name: '岗位名称',
                  key: 'gwmc',
                },
                {
                  name: '企业老师',
                  key: 'qyls',
                },
                {
                  name: '企业老师电话',
                  key: 'qylsdh',
                },
                {
                  name: '岗位类别',
                  key: 'gwlbmc',
                },
                {
                  name: '岗位介绍',
                  key: 'gwjs',
                },
                {
                  name: '工作内容',
                  key: 'gznr',
                },
              ],
            },
            {
              title: '实习信息', // 盒子标题
              list: [
                {
                  name: '校内指导教师',
                  key: 'xnzdjsmc',
                },
                {
                  name: '开始时间',
                  key: 'kssj',
                },
                {
                  name: '结束时间',
                  key: 'jssj',
                },
                {
                  name: '专业对口',
                  key: 'zydk',
                },
                {
                  name: '附件',
                  key: 'base64',
                },
              ],
            },
          ],
          infoList_14475: [
            // 用户填写的信息列表
            {
              title: '企事业单位信息', // 盒子标题
              list: [
                {
                  name: '实习基地',
                  key: 'sxjdmc',
                },
                {
                  name: '所属单位',
                  key: 'ssqy',
                },
                {
                  name: '基地类别',
                  key: 'jdlbmc',
                },
                {
                  name: '基地负责人',
                  key: 'jdfzr',
                },
                {
                  name: '基地电话',
                  key: 'jddh',
                },
                {
                  name: '基地地址',
                  key: 'jddz',
                },
              ],
            },
            {
              title: '岗位信息', // 盒子标题
              list: [
                {
                  name: '部门/科室',
                  key: 'bmks',
                },
                {
                  name: '岗位名称',
                  key: 'gwmc',
                },
                {
                  name: '企业老师',
                  key: 'qyls',
                },
                {
                  name: '企业老师电话',
                  key: 'qylsdh',
                },
                {
                  name: '岗位类别',
                  key: 'gwlbmc',
                },
                {
                  name: '岗位介绍',
                  key: 'gwjs',
                },
                {
                  name: '工作内容',
                  key: 'gznr',
                },
              ],
            },
            {
              title: '实习信息', // 盒子标题
              list: [
                {
                  name: '校内指导教师',
                  key: 'xnzdjsmc',
                },
                {
                  name: '开始时间',
                  key: 'kssj',
                },
                {
                  name: '结束时间',
                  key: 'jssj',
                },
                {
                  name: '专业对口',
                  key: 'zydk',
                },
                {
                  name: '附件',
                  key: 'base64',
                },
              ],
            },
          ],
          infoList_10422: [
            // 用户填写的信息列表
            {
              title: '企事业单位信息', // 盒子标题
              list: [
                {
                  name: '实习基地',
                  key: 'sxjdmc',
                },
                {
                  name: '所属单位',
                  key: 'ssqy',
                },
                {
                  name: '基地类别',
                  key: 'jdlbmc',
                },
                {
                  name: '基地负责人',
                  key: 'jdfzr',
                },
                {
                  name: '基地电话',
                  key: 'jddh',
                },
                {
                  name: '基地地址',
                  key: 'jddz',
                },
              ],
            },
            {
              title: '实习信息', // 盒子标题
              list: [
                {
                  name: '校内指导教师',
                  key: 'xnzdjsmc',
                },
                {
                  name: '开始时间',
                  key: 'kssj',
                },
                {
                  name: '结束时间',
                  key: 'jssj',
                },
                {
                  name: '专业对口',
                  key: 'zydk',
                },
                {
                  name: '附件',
                  key: 'base64',
                },
              ],
            },
          ],
        },
        // 分散实习配置
        {
          pageTitle: '实习变更',
          type: '实习变更',
          title: 'title',
          name: 'xsxm',
          classId: 'bj',
          studentId: 'xh',
          status: 'iswfmes', // 状态
          refuseReason: 'shyj', // 审核意见
          iApi: '/sxbgsqController/getFssxbgxq',
          infoList: [
            // 用户填写的信息列表
            {
              title: '企事业单位信息', // 盒子标题
              list: [
                {
                  name: '企业名称',
                  key: 'sxqymctext',
                },
                {
                  name: '打卡企业',
                  key: 'sxqymc',
                },
                {
                  name: '统一社会信用代码',
                  key: 'tyshxydm',
                },
                {
                  name: '企业性质',
                  key: 'qyxzmc',
                },
                {
                  name: '行业类别',
                  key: 'hylbmc',
                },
                {
                  name: '所属行业',
                  key: 'sshymc',
                },
                {
                  name: '所在城市',
                  key: 'csmc',
                },
                {
                  name: '详细地址',
                  key: 'qyxxdz',
                },
                {
                  name: '企业人数规模',
                  key: 'qygmrs',
                },
                {
                  name: '企业联系人',
                  key: 'qylxr',
                },
                {
                  name: '基地电话',
                  key: 'lxrdh',
                },
                {
                  name: '联系人邮箱',
                  key: 'lxryx',
                },
              ],
            },
            {
              title: '岗位信息', // 盒子标题
              list: [
                {
                  name: '部门/科室',
                  key: 'bmks',
                },
                {
                  name: '岗位名称',
                  key: 'gwlxmc',
                },
                {
                  name: '企业老师',
                  key: 'qyls',
                },
                {
                  name: '企业老师电话',
                  key: 'qylsdh',
                },
                {
                  name: '岗位类别',
                  key: 'gwlb',
                },
                {
                  name: '岗位介绍',
                  key: 'gwjs',
                },
                {
                  name: '工作内容',
                  key: 'gznr',
                },
              ],
            },
            {
              title: '实习信息', // 盒子标题
              list: [
                {
                  name: '校内指导教师',
                  key: 'xnzdjsmc',
                },
                {
                  name: '开始时间',
                  key: 'kssj',
                },
                {
                  name: '结束时间',
                  key: 'jssj',
                },
                {
                  name: '专业对口',
                  key: 'zydkmc',
                },
                {
                  name: '附件',
                  key: 'base64',
                },
              ],
            },
          ],
          infoList_14475: [
            // 用户填写的信息列表
            {
              title: '企事业单位信息', // 盒子标题
              list: [
                {
                  name: '企业名称',
                  key: 'sxqymctext',
                },
                {
                  name: '打卡企业',
                  key: 'sxqymc',
                },
                {
                  name: '统一社会信用代码',
                  key: 'tyshxydm',
                },
                {
                  name: '企业性质',
                  key: 'qyxzmc',
                },
                {
                  name: '行业类别',
                  key: 'hylbmc',
                },
                {
                  name: '所属行业',
                  key: 'sshymc',
                },
                {
                  name: '所在城市',
                  key: 'csmc',
                },
                {
                  name: '详细地址',
                  key: 'qyxxdz',
                },
                {
                  name: '企业人数规模',
                  key: 'qygmrs',
                },
                {
                  name: '企业联系人',
                  key: 'qylxr',
                },
                {
                  name: '基地电话',
                  key: 'lxrdh',
                },
                {
                  name: '联系人邮箱',
                  key: 'lxryx',
                },
              ],
            },
            {
              title: '岗位信息', // 盒子标题
              list: [
                {
                  name: '部门/科室',
                  key: 'bmks',
                },
                {
                  name: '岗位名称',
                  key: 'gwlxmc',
                },
                {
                  name: '企业老师',
                  key: 'qyls',
                },
                {
                  name: '企业老师电话',
                  key: 'qylsdh',
                },
                {
                  name: '岗位类别',
                  key: 'gwlb',
                },
                {
                  name: '岗位介绍',
                  key: 'gwjs',
                },
                {
                  name: '工作内容',
                  key: 'gznr',
                },
                {
                  name: '手机号码',
                  key: 'sjhm',
                },
                {
                  name: '实习天数(天/周)',
                  key: 'sxts',
                },
                {
                  name: '实习时长(小时/天)',
                  key: 'sxsc',
                },
                {
                  name: '实习报酬(元/月)',
                  key: 'sxbc',
                },
              ],
            },
            {
              title: '实习信息', // 盒子标题
              list: [
                {
                  name: '校内指导教师',
                  key: 'xnzdjsmc',
                },
                {
                  name: '开始时间',
                  key: 'kssj',
                },
                {
                  name: '结束时间',
                  key: 'jssj',
                },
                {
                  name: '专业对口',
                  key: 'zydkmc',
                },
                {
                  name: '附件',
                  key: 'base64',
                },
              ],
            },
          ],
          infoList_10422: [
            // 用户填写的信息列表
            {
              title: '企事业单位信息', // 盒子标题
              list: [
                {
                  name: '企业名称',
                  key: 'sxqymctext',
                },
                {
                  name: '打卡企业',
                  key: 'sxqymc',
                },
                {
                  name: '统一社会信用代码',
                  key: 'tyshxydm',
                },
                {
                  name: '企业性质',
                  key: 'qyxzmc',
                },
                {
                  name: '行业类别',
                  key: 'hylbmc',
                },
                {
                  name: '所属行业',
                  key: 'sshymc',
                },
                {
                  name: '所在城市',
                  key: 'csmc',
                },
                {
                  name: '详细地址',
                  key: 'qyxxdz',
                },
                {
                  name: '企业人数规模',
                  key: 'qygmrs',
                },
                {
                  name: '企业联系人',
                  key: 'qylxr',
                },
                {
                  name: '基地电话',
                  key: 'lxrdh',
                },
                {
                  name: '联系人邮箱',
                  key: 'lxryx',
                },
              ],
            },
            {
              title: '实习信息', // 盒子标题
              list: [
                {
                  name: '校内指导教师',
                  key: 'xnzdjsmc',
                },
                {
                  name: '开始时间',
                  key: 'kssj',
                },
                {
                  name: '结束时间',
                  key: 'jssj',
                },
                {
                  name: '专业对口',
                  key: 'zydkmc',
                },
                {
                  name: '附件',
                  key: 'base64',
                },
              ],
            },
          ],
        },
        // 结束实习配置
        {
          pageTitle: '结束实习',
          type: '结束实习',
          title: 'jhname',
          name: 'name',
          classId: 'bj',
          studentId: 'stunum',
          status: 'shzt', // 状态
          refuseReason: 'shyj', // 审核意见
          // iApi: '/xsDgsx/getSxXx',
          iApi: '/xsDgsx/getSxJsZt',
          infoList: [
            // 用户填写的信息列表
            {
              title: '', // 盒子标题
              list: [
                {
                  name: '申请提交时间',
                  key: 'sqsj',
                },
                {
                  name: '实习单位',
                  key: 'company',
                },
                {
                  name: '部门/科室',
                  key: 'depart',
                },
                {
                  name: '实习岗位',
                  key: 'pos',
                },
                {
                  name: '实习开始时间',
                  key: 'starttime',
                },
                {
                  name: '实习结束时间',
                  key: 'endtime',
                },
              ],
            },
          ],
          infoList_14475: [
            // 用户填写的信息列表
            {
              title: '', // 盒子标题
              list: [
                {
                  name: '申请提交时间',
                  key: 'sqsj',
                },
                {
                  name: '实习单位',
                  key: 'company',
                },
                {
                  name: '部门/科室',
                  key: 'depart',
                },
                {
                  name: '实习岗位',
                  key: 'pos',
                },
                {
                  name: '实习开始时间',
                  key: 'starttime',
                },
                {
                  name: '实习结束时间',
                  key: 'endtime',
                },
              ],
            },
          ],
          infoList_10422: [
            // 用户填写的信息列表
            {
              title: '', // 盒子标题
              list: [
                {
                  name: '申请提交时间',
                  key: 'sqsj',
                },
                {
                  name: '实习单位',
                  key: 'company',
                },
                {
                  name: '实习开始时间',
                  key: 'starttime',
                },
                {
                  name: '实习结束时间',
                  key: 'endtime',
                },
              ],
            },
          ],
        },
      ],
    }
  },
  computed: {
    ...mapGetters({
      sxjhid: 'getSxjhid',
      isty: 'getIsty',
    }),
    getStatusColor() {
      return status => {
        let color = ['#F85352', '#41B29C', '#FFA400', '#FFA400', '#B2B2B2']
        return color[parseInt(status)]
      }
    },
    getItemType() {
      return name => {
        let list = ['工作内容', '岗位介绍', '附件', '项目描述', '自我评价', '申请原因', '证明文件', '详细地址']
        if (list.includes(name)) {
          return true
        }
        return false
      }
    },
    getItemTypePictrue() {
      return name => {
        let list = ['附件', '证明文件', '图片', '证明材料','用人单位录用函']
        if (list.includes(name)) {
          return true
        }
        return false
      }
    },
    getRejectColor() {
      if (this.pageData[this.config[this.pageIndex].status] === '0') {
        return 'linear-gradient(130deg, #F85352 0%, #F88F52 100%)'
      } else {
        return 'linear-gradient(130deg, #FFFFFF 0%, #FFFFFF 100%)'
      }
    },
    getRejectTextColor() {
      if (this.pageData[this.config[this.pageIndex].status] === '1') {
        return '#333333'
      } else {
        return '#FFFFFF'
      }
    },
  },
  methods: {
    async getStatus() {
      const res = await iApi.getApplyStatus({
        url: this.config[this.pageIndex].iApi,
        data: this.params,
      })
      this.pageData = res.data
      console.log(this.config[this.pageIndex].status)
      console.log(this.pageData[this.config[this.pageIndex].status])
    },
    reApply() {
      let path = ''
      if (this.pageIndex == 1) {
        path = '/internship/applyFor?isEdit=true&active=1'
      } else if (this.pageIndex == 2) {
        localStorage.setItem('edit', JSON.stringify(this.config[this.pageIndex].infoList))
        path = `/internship/addJobs?isEdit=true&sxxmid=${this.$route.query.sxxmid}`
      } else if (this.pageIndex == 3) {
        path = `/internship/exemptionApplication?isEdit=true`
      } else if (this.pageIndex == 4) {
        path = `/internship/freeSignList?isEdit=true&active=0&mqid=${this.params.mqid}`
      } else if (this.pageIndex == 5) {
        path = `/internship/askLevelList?isEdit=true&active=0&qjid=${this.params.qjid}`
      } else if (this.pageIndex == 6) {
        path = `/internship/uniChange?isEdit=true`
      } else if (this.pageIndex == 7) {
        path = `/internship/disperseChange?isEdit=true`
      }else if(this.pageIndex == 8){
         path = `/internship/done?isEdit=true`
      }
      if (this.pageIndex == 4 || this.pageIndex == 5) {
        this.$router.replace(path)
      } else {
        this.$router.push({
          path: path,
        })
      }
    },
  },
  created() {
    this.schoolCode = sessionStorage.getItem("schoolCode");
    if (this.$route.query) {
      this.pageIndex = this.$route.query.config
      if (this.pageIndex == 1 || this.pageIndex == 3 || this.pageIndex == 6 || this.pageIndex == 7 || this.pageIndex == 8) {
        this.params = {
          sxjhid: this.sxjhid,
        }
      } else if (this.pageIndex == 2) {
        this.params = {
          sxxmid: this.$route.query.sxxmid,
        }
      } else if (this.pageIndex == 4) {
        this.params = {
          mqid: this.$route.query.mqid,
        }
      } else if (this.pageIndex == 5) {
        this.params = {
          qjid: this.$route.query.qjid,
        }
      }
    }
    this.getStatus()
  },
}
</script>
<style lang="less" scoped>
.page {
  background: #f2f2f4;
  min-height: 100vh;
  padding-bottom: 100px;
  margin-top: -50px;
}

.header {
  padding: 15px;
  height: 70px;
  background: #ffffff;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.08);
  border-radius: 0 0 8px 8px;
  display: flex;
  justify-content: space-between;

  .left {
    flex: 1;

    .title {
      width: 250px;
      font-family: PingFangSC-Medium;
      font-weight: 500;
      font-size: 20px;
      color: #353535;
      line-height: 22px;
      margin-bottom: 10px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .info {
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 14px;
      color: #999999;
    }
  }

  img {
    width: 89px;
    height: 70px;
  }
}

.change-box {
  width: 315px;
  // min-height: 160px;
  background: #ffffff;
  border-radius: 8px;
  margin: 10px auto;
  padding: 15px;
  padding-bottom: 0;

  .item-box {
    // margin-top: 15px;
    border-bottom: 1px dashed #e5e5e5;

    .title {
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 12px;
      color: #999999;
      margin-bottom: 15px;
    }

    .change-item {
      margin-left: 6px;
      // margin-top: 10px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 14px;
      color: #333333;
      border-left: 2px solid #d8d8d8;
      position: relative;
      height: 30px;
      padding-left: 10px;

      .point {
        width: 6px;
        height: 6px;
        background: #d8d8d8;
        border-radius: 50%;
        position: absolute;
        transform: translate(-50%, -50%);
        left: -1px;
        top: 0px;
      }

      .name {
        line-height: 0px;
      }
    }
  }
}

.reject-box {
  width: 315px;
  min-height: 44px;
  background-image: linear-gradient(130deg, #f85352 0%, #f88f52 100%);
  border-radius: 8px;
  margin: 10px auto 0;
  padding: 15px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  font-size: 14px;
  color: #ffffff;
}

.info-box {
  .title {
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 14px;
    color: #666666;
    margin-top: 14px;
    margin-bottom: 6px;
    margin-left: 15px;
  }

  .item-box {
    width: 345px;
    min-height: 100px;
    border-radius: 8px;
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.08);
    margin: 0 auto;
    background: #ffffff;

    .item {
      display: flex;
      justify-content: space-between;
      min-height: 20px;
      padding: 15px;
      border-bottom: 1px solid #e5e5e5;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 16px;

      .name {
        min-width: 106px;
        color: #333333;
      }

      .content {
        color: #666666;
        flex: 1;
        text-align: right;
      }
    }

    .column {
      flex-direction: column;
      justify-content: center;

      .content {
        text-align: left;
      }
    }
  }
}

.button-box {
  width: 375px;
  height: 70px;
  background: #ffffff;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .button {
    width: 345px;
    height: 50px;
    background: #0189f9;
    border-radius: 25px;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    font-size: 18px;
    color: #ffffff;
    text-align: center;
    line-height: 50px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/student/internship/applyStatus.vue